import { render, staticRenderFns } from "./SectionItemSubgroup.vue?vue&type=template&id=08e5def0&scoped=true"
import script from "./SectionItemSubgroup.vue?vue&type=script&lang=ts"
export * from "./SectionItemSubgroup.vue?vue&type=script&lang=ts"
import style0 from "./SectionItemSubgroup.vue?vue&type=style&index=0&id=08e5def0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e5def0",
  null
  
)

export default component.exports